import Image from "next/image";
import { cn } from "../../utils/cn";

interface ComboCardProps {
	title: string;
	description: string;
	logoSrc: string;
	logoAlt: string;
	backgroundSrc: string;
	meshBackground: string;
}

const ComboCard: React.FC<ComboCardProps> = ({
	title,
	description,
	logoSrc,
	logoAlt,
	backgroundSrc,
	meshBackground,
}) => {
	return (
		<div
			className={cn(
				"relative h-[199px] flex-shrink-0 rounded-2xl cursor-pointer  transition-transform overflow-hidden",
				"hover:-translate-y-1",
			)}
			style={{
				background: `linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), url('${meshBackground}') lightgray center/cover no-repeat`,
			}}
		>
			{/* Background Image */}
			<div className="absolute inset-0 pointer-events-none">
				<Image
					src={backgroundSrc}
					alt="Background"
					fill
					className="object-cover hover:scale-125"
				/>
			</div>
			<div className="relative flex w-[315px] flex-col items-start gap-[78px] p-6 z-10">
				<Image
					src={logoSrc}
					alt={logoAlt}
					width={0}
					height={24}
					style={{ width: "auto" }}
				/>
				<h3
					className="text-white font-inter text-[20px] font-semibold leading-[120%] mb-1"
					style={{ fontStyle: "normal" }}
				>
					{description}
				</h3>
			</div>
		</div>
	);
};

export default ComboCard;
